import { FieldRequirement } from '../../../models/fieldRules'

function resolveEffectiveRequirement(
  parent: FieldRequirement,
  child: FieldRequirement,
) {
  if (parent === 'forbidden') return 'forbidden'
  if (parent === 'required') return child

  return child === 'required' ? 'optional' : child
}

export default resolveEffectiveRequirement
